/* eslint-enable */
/* eslint-enable */

class AnimationSingleLocation {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleSingleLocation = this.sectionsContainer.querySelectorAll('.single-location');
		
		if (!this.$moduleSingleLocation.length)
			return;
		
		this.$moduleSingleLocationElements = [];

		this.$moduleSingleLocation.forEach(module => {
			this.$moduleSingleLocationElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleSingleLocation.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleSingleLocationElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleSingleLocation = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleSingleLocation[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleSingleLocationElements[index], { clearProps: true });
			}
        });
    
        this.moduleSingleLocation.addLabel('step1');
        this.moduleSingleLocation.to(this.$moduleSingleLocation[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleSingleLocation.to(this.$moduleSingleLocationElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default AnimationSingleLocation;
